import React from 'react';
import PropTypes from 'prop-types';
import CouponIcon from 'components/svg/CouponIcon';

import './DealsBanner.scss';

export function DealsBanner({ text }) {
	return (
		<div className="deals-banner-wrapper">
			<div className="deals-banner">
				<CouponIcon />
				<span className="deals-banner-text">{text}</span>
			</div>
		</div>
	);
}

DealsBanner.propTypes = {
	text: PropTypes.string.isRequired,
};

export default DealsBanner;
